import { Component } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ContactFormComponent } from '../contact-form/contact-form.component';

@Component({
  selector: 'app-customer-contact-modal',
  standalone: true,
  imports: [ContactFormComponent],
  templateUrl: './customer-contact-modal.component.html',
  styleUrls: ['./customer-contact-modal.component.scss']
})
export class CustomerContactModalComponent {
  modalRef: NgbModalRef | undefined;

  onSubmitted() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  onCancelled() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
}
